import { makeStyles } from '../styles';
const useScrollStyles = makeStyles(({ spacing }) => ({
    scroll: {
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            '-webkit-appearance': 'none',
            '&:vertical': {
                width: spacing(),
            },
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: spacing(),
            border: 'none',
            backgroundColor: 'rgba(0, 0, 0, .4)',
        },
    },
}));
export default useScrollStyles;
//# sourceMappingURL=scroll.styles.js.map